
export function configkey() {
	return {
		"stock_index_prediction": [
		  "stock_index_prediction_entry_switch"
		],
		"site": [
		  "company",
		  "logo",
		  "logo_image",
		  "logo_exe",
		  "online_service",
		  "online_service_1",
		  "online_service_2",
		  "site_beian",
		  "site_copyright",
		  "site_ico",
		  "site_name",
		  "site_version",
		  "websocket",
		  "frontDeskDomain",
		  "seo_title",
		  "seo_keywords",
		  "seo_description",
		  "seo_description",
		  "invite_code_switch",
		  "frontDaoHangDomain",
		  "site_pc_url",
		  "online_qq", //在线qq
		   "site_address",//公司地址
		   "site_tel",  //公司电话
		   "market_open",//交易日   
		  "site_intercept",
		  "scan_paopao_code",
		  "wechat_scan",
		  "is_meijia",
		  "meijia_uid",
		  "chat_switch",
		  "site_email",
		  "is_linkchat",
		  "linkchat_uid",
		  "is_duomi",
		  "duomi_uid",
		  "is_miduoke",
		  "miduoke_uid",
		  "miduoke_domain"
		],
		"app": [
		  "android",
		  "android_scan",
		  "iosApp",
		  "iosApp_scan",
		  "iosH5_scan",
		  "ios_app_version",
		  "android_app_version",
		  "ios_app_down_url",
		  "android_app_down_url",
		  "popup_switch",
		  "api_speed_switch",
		  "slide_verify_switch",
		  "calculation_code_switch",
		  "login_calculation_switch",
		  "app_num_key",
		  "app_force_update",
		  "app_beginner_guide",
		  "ios_appstore_url",
		  "app_hide_menu",
		  "quick_recharge_logo",
		  "quick_recharge_switch",
		  "quick_recharge_exclusive_jump",
		  "quick_recharge_jump",
		  "real_name_bank_bind",
		  "suy_pay_passwd_show",
		  "stock_front_auto",
		  "more_kefu",
		  "open_chat_room"
		],
  
		"consult": [
		  "free_trial_switch",
		  "free_trial_funds",
		  "free_trial_deposit",
		  "loss_warn_ratio",
		  "loss_close_ratio",
		  "open_consult",
		],
		"balance_baby": [
		  "balance_baby_switch",
		  "balance_baby_image",
		  "balance_baby_name",
		  "interest_rate",
		],
		"zhaoyingbao": [
		  "zyb_switch",
		  "zyb_alias",
		  "zyb_rate",
		],
		"third": [
		  "third_channel_open",
		],
		"sms":[
		  "register_switch", "sms_status"
		],
		"turntable":[
			"turntable_status"
		],
		"task":[
			 "task_switch",
		   "task_center_open"
		],
		"mentor":[
			"mentor_buying_instructions",
			'mentor_partner_switch',
			"mentor_profit_time",
		],
		"trade":[
			"stock_index_service",
			"stock_hk_service",
			"stock_us_service",
			"invest_service"
		],
	  }
  }

